import { useQuery } from '@tanstack/react-query'
import { getRecentVerticals } from '@pepper/utils/src/api/companies/companies'

type ReturnType = {
  isError: boolean
  data: VerticalID[]
  refetch: () => void
  isLoading: boolean
}

export const useRecentVerticals = (companyId: string): ReturnType => {
  const handleApiRequest = async () => {
    const { status, data, error } = await getRecentVerticals(companyId)
    if (status === 'ok' && data) {
      return data.response || data
    } else {
      throw new Error(error)
    }
  }

  const { isError, isLoading, data, refetch } = useQuery<VerticalID[], Error>({
    queryKey: ['recent-vertical'],
    queryFn: handleApiRequest
  })

  return {
    isError,
    isLoading,
    data: data ?? [],
    refetch
  }
}
